import React from 'react';
import { motion } from 'framer-motion';
import { Ornament, Signature } from './graphics/Graphics';
export function DoctorIntro() {
  return <section className="bg-offwhite py-12 md:py-20 px-5" data-id="element-74">
      <div className="max-w-[780px] mx-auto" data-id="element-75">
        {/* Metadata */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-inter text-[13px] text-secondary space-y-1 mb-6" data-id="element-76">
          <div data-id="element-77">Women's Health & Wellbeing | UK Edition</div>
          <div data-id="element-78">
            By Dr. Sarah Mitchell, NHS Continence Specialist (Ret.) | 20 Years
            Clinical Experience
          </div>
          <div data-id="element-79">Updated: May 2026</div>
        </motion.div>

        <div className="w-full h-[1px] bg-divider mb-8" data-id="element-80"></div>

        {/* Doctor Card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-cream rounded-xl p-6 md:p-7 mb-8 flex flex-col sm:flex-row items-center sm:items-start gap-5 shadow-subtle" data-id="element-81">
          <img src="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80" alt="Dr. Sarah Mitchell" className="w-[72px] h-[72px] rounded-full object-cover shrink-0" data-id="element-82" />
          <div className="text-center sm:text-left" data-id="element-83">
            <div className="font-inter font-semibold text-[15px] text-ink mb-1" data-id="element-84">
              Dr. Sarah Mitchell
            </div>
            <div className="font-inter text-[13px] text-secondary leading-relaxed" data-id="element-85">
              NHS Continence Specialist (Ret.) | BSc (Hons) Medicine, University
              of Manchester | 20 Years NHS Clinical Practice
            </div>
          </div>
        </motion.div>

        {/* Body Copy */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-inter text-[16px] text-ink leading-[1.75] space-y-5" data-id="element-86">
          <p data-id="element-87">
            If you are a woman over fifty in the UK, you have likely had a
            conversation with your GP about your bladder. And if you are like
            most of the women I saw in my clinic, that conversation was probably
            brief, slightly dismissive, and ultimately unhelpful.
          </p>
          <p data-id="element-88">
            You were probably told to do your pelvic floor exercises. You might
            have been handed a leaflet. And you were almost certainly told
            something along these lines:
          </p>

          <div className="border-l-[3px] border-gold pl-5 my-8" data-id="element-89">
            <p className="font-playfair italic text-[18px] text-ink leading-relaxed" data-id="element-90">
              "It's very common at your age. Have you tried pelvic floor
              exercises? There are some good pads available now."
            </p>
          </div>

          <motion.figure initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="my-8" data-id="element-91">
            <img src="https://cdn.magicpatterns.com/uploads/4Voe8U5s77WhSheV3ndNFw/imgi_4_1773956276-imgi_3_1764949757-1759803156-imgi_5_1748523505-1733206543-Screenshot_2024-12-03_141357.webp" alt="A woman experiencing bladder discomfort" className="w-full h-auto rounded-xl shadow-subtle object-cover aspect-[16/10]" data-id="element-92" />
            <figcaption className="font-inter text-[12px] italic text-secondary mt-2 text-center" data-id="element-93">
              The reality the leaflet does not address.
            </figcaption>
          </motion.figure>

          <p data-id="element-94">
            This advice is not just frustrating; it fundamentally misunderstands
            what is happening in your body. We have conditioned an entire
            generation of women to believe that leaking is an inevitable part of
            ageing, and that the only solution is to manage the mess.
          </p>

          <div className="flex justify-center my-6" data-id="element-95">
            <Ornament color="#C9A96E" width={70} data-id="element-96" />
          </div>

          <p className="font-bold text-forest text-[18px]" data-id="element-97">
            Pads do not treat incontinence. They contain the result of it.
          </p>

          <p data-id="element-98">
            For twenty years in the NHS, I watched women alter their entire
            lives around their bladders. They stopped running. They mapped out
            public toilets before leaving the house. They wore dark trousers in
            summer. They accepted a diminished version of their lives because
            they were told there was no other option.
          </p>
          <p data-id="element-99">
            But the science of continence has moved on. We now know that for
            many women, the issue isn't just a weak muscle — it's a breakdown in
            the communication between the nerve and the muscle. And finally,
            there is a way to address that directly, without a prescription.
          </p>
        </motion.div>
      </div>
    </section>;
}